<script>
  import {
    Row,
    Col,
    Container,
    Button,
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    Spinner
  } from "sveltestrap";

  export let auth;

  let login;

  const signIn = () => {
    login = auth.signInAnonymously();
  };
</script>

<style>

</style>

<Container class="min-vh-100">
  <Row class="min-vh-100">
    <Col class="align-self-center">
      <Card style="width: 18rem;" class="text-center mx-auto" color="dark">
        <CardHeader>
          <CardTitle>
            <h3 class="mt-2 text-white">Eph Chat</h3>
          </CardTitle>
        </CardHeader>
        <CardBody>
          <Button color="primary" on:click={() => signIn()}>
            {#await login}
              <Spinner color="light" size="sm" />
            {:then}
              Sign In Anonymously
            {/await}
          </Button>
        </CardBody>
      </Card>
    </Col>
  </Row>
</Container>
